import { Stack } from "@mui/material";

import { useState } from "react";

import { patch } from "../../apiClient";

import AudienceFloorProductSetting from "./components/AudienceFloorProductSetting";
import AudiencePricePerTimeOnSiteTable from "./components/AudiencePricePerTimeOnSiteTable";

const DEFAULT_TIME_ON_SITES = {
  10: null,
  15: null,
  20: null,
  30: null,
  40: null,
  60: null,
};

const action = async ({ request, params }) => {
  const formData = await request.formData();
  const payload = {
    ...Object.fromEntries(formData),
    base_rate: formData.get("base_rate") && Number(formData.get("base_rate")),
  };

  return patch(
    "managed_plus",
    `/pricing/account_audience_floors/${params.accountId}`,
    payload
  );
};

const AccountTimeOnSiteForm = () => {
  const [state, setState] = useState({});

  return (
    <Stack spacing={3}>
      <AudienceFloorProductSetting
        onChange={(values) => setState(values)}
        onClear={(values) => setState(values)}
      />
      <AudiencePricePerTimeOnSiteTable
        data={{
          audience_floors: state.data?.audience_floors || DEFAULT_TIME_ON_SITES,
          data_revenue_share: state.data?.data_revenue_share,
        }}
        onUpdated={(newData) =>
          setState((prev) => ({ ...prev, data: newData }))
        }
        currentQuery={state.query}
        isEditing={!!state.editing}
        onCancel={() => setState({})}
      />
    </Stack>
  );
};

export { action };
export default AccountTimeOnSiteForm;
